import { Component, inject, input, linkedSignal } from '@angular/core';
import { IconComponent } from '@nagel-assests';
import { LegTourPointConfig } from 'apps/nagel-cal-disposition/src/models/planningPageTypes';
import { DraggableCardInfoChipComponent } from '../../draggable-card/draggable-card-info-chip/draggable-card-info-chip.component';
import { MatButtonModule } from '@angular/material/button';
import { ChipComponent } from '@nagel-components';
import { AssignedLegManagementService } from '../../../services/assigned-leg-management.service';
import { OmsLinkService } from '../../../services/oms-link.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'cal-leg-tour-point',
    standalone: true,
    imports: [
        IconComponent,
        DraggableCardInfoChipComponent,
        MatButtonModule,
        ChipComponent,
        MatTooltipModule
    ],
    templateUrl: './leg-tour-point.component.html',
    styleUrl: './leg-tour-point.component.scss'
})
export class LegTourPointComponent {
    legTourPoint = input<LegTourPointConfig>({
        legId: '',
        shipmentNumber: 0,
        shipmentId: 0,
        order: 0,
        name: null,
        country: null,
        city: null,
        street: null,
        zipCode: null,
        locationIdentifier: null,
        weight: null,
        volumePalletSpaces: null,
        volumePalletSpacesIdentifier: null,
        floorPalletSpaces: null,
        floorPalletSpacesIdentifier: null,
        destinationCountry: null,
        consigneeServiceArea: null,
        serviceAreaIdentifier: null,
        fixedDeliveryDate: null,
        deliveryDateFrom: null,
        deliveryDateTo: null,
        pickupDateFrom: null,
        pickupDateTo: null,
        trafficIcon: '',
        infoChips: [],
        checked: false,
        staysLoaded: false
    });

    staysLoaded = linkedSignal(() => this.legTourPoint().staysLoaded ?? false);

    isDisabled = input<boolean>(false);
    isEligibleForLoadingLegs = input<boolean>(false);
    protected omsLinkService =inject(OmsLinkService);

    constructor(
        private assignedLegManagementService: AssignedLegManagementService,
    ) {}

    getTooltipText = () => {
        return this.getIsOmsEditDisabled()
            ? $localize`This shipment is not available on OMS`
            : $localize`Edit shipment in OMS`;
    };


    iconType = input<string>('');

    stayLoadedClick = (event: MouseEvent) => {
        if (!this.isDisabled()) {
            this.assignedLegManagementService.markLegStaysLoaded(
                this.legTourPoint(),
                this.staysLoaded
            );
            event.stopPropagation();
            event.preventDefault();
        }
    };

    getIsOmsEditDisabled = () => {
        return this.isDisabled() || !this.omsLinkService.getIsOmsLinkAvailable(this.legTourPoint().shipmentId);
    };

    keydown = (/*event: KeyboardEvent*/) => {
    };

}